import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AlertsComponent } from "./playground/alerts/alerts.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TimetrackingComponent } from "./timetracking/timetracking.component";
import { AccountModule } from "./account/account.module";
import { AuthInterceptor } from "./shared/security/auth.interceptor";
import { NavBarComponent } from "./nav-bar/nav-bar.component";
import { AppLinkComponent } from "./nav-bar/app-link/app-link.component";
import { TimeAddComponent } from "./timetracking/time-add/time-add.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DecimalPipe } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ModalContainerComponent } from "./modal-container/modal-container.component";
import { CustomPipesModule } from "./shared/pipes/custom-pipes.module";
import { TimeListComponent } from "./timetracking/time-list/time-list.component";
import { TimeEditComponent } from "./timetracking/time-edit/time-edit.component";
import { TimeDeleteComponent } from "./timetracking/time-delete/time-delete.component";
import { TimeFormComponent } from "./timetracking/time-form/time-form.component";
import { SharedComponentsModule } from "./shared/components/shared-components.module";
import { WorkingNotificationModule } from "./shared/working-notification/working-notification.module";
import { ChooseProjectComponent } from "./admin/work-orders/choose-project/choose-project.component";
import { ChooseWorkOrderComponent } from "./admin/work-orders/choose-workorder/choose-workorder.component";
import { ChooseWorkorderComponent } from "./admin/projects/choose-workorder/choose-workorder.component";
import { CustomDiretivesModule } from "./shared/directives/custom-diretives.module";
import { OrgChartComponent } from "./org-chart/org-chart.component";
import { TreeComponent } from "./org-chart/tree/tree.component";
import { TreeNodeComponent } from "./org-chart/tree-node/tree-node.component";
import { ErrorPageComponent } from './error/error/error-page.component';

@NgModule({
  declarations: [
    AppComponent,
    AlertsComponent,
    TimetrackingComponent, // TODO should each main navigation be its own module, instead of in app
    NavBarComponent,
    AppLinkComponent,
    TimeAddComponent,
    ModalContainerComponent,
    TimeListComponent,
    TimeEditComponent,
    TimeDeleteComponent,
    TimeFormComponent,
    // entry components used by lazy loaded modules
    ChooseProjectComponent,
    ChooseWorkOrderComponent,
    ChooseWorkorderComponent,
    OrgChartComponent,
    TreeComponent,
    TreeNodeComponent,
    ErrorPageComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    NgbModule,
    // only load account and timetracking modules at first
    // timetracking is just baked into app component right now
    AccountModule,
    AppRoutingModule,
    // TODO right now im bringing these in for time tracking. time tracking should have its own module
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CustomPipesModule,
    SharedComponentsModule,
    WorkingNotificationModule,
    CustomDiretivesModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    DecimalPipe,
  ],
  entryComponents: [
    TimeAddComponent,
    ChooseProjectComponent,
    ChooseWorkOrderComponent,
    ChooseWorkorderComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
